/**
 * Created by Kotkin on 16.04.18.
 */
/* eslint-disable import/prefer-default-export */

import React, { Component } from 'react';
import { UserProp } from 'auth';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import { emit } from 'helpers/global-events';
import { I18nHoc } from 'helpers/i18n';
import map from 'lodash/map';
import isArray from 'lodash/isArray';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import includes from 'lodash/includes';
import Notification from 'components/notification';

import translates from '../forum-i18n';

// declare api request params for single and multi post removing
const deletePostConfig = (multi, posts) => {
  // delete single post
  if (!multi) {
    return {
      apiMethod: 'delete',
      apiUrl: 'form/forum/post-form/data',
      postData: {
        post_id: posts.id
      },
      afterRemove: [posts]
    };
  }
  // delete multi posts
  return {
    apiMethod: 'post',
    apiUrl: 'action/forum/actions-remove-posts/remove-posts',
    postData: {
      posts_id: map(posts, post => post.id)
    },
    afterRemove: posts
  };
};

/**
 *
 * === withPostEditing decorator ===
 * is used to select/delete posts.
 *
 */

@apiDecorator
export function withPostEditing(WrappedComponent) {
  @I18nHoc(translates())
  class PostEditor extends Component {
    static propTypes = {
      auth: UserProp
    };

    constructor(props, context) {
      super(props, context);
      this.onHandleSelectPost = this.onHandleSelectPost.bind(this);
      this.onHandleDeletePost = this.onHandleDeletePost.bind(this);

      this.state = {
        selectedPosts: null
      };
    }

    componentWillReceiveProps({ auth: nextAuth = {} }) {
      const { auth = {} } = this.props;

      if (
        (!auth.authenticated && auth.authenticated !== nextAuth.authenticated) ||
        (auth.authenticated && auth.authenticated !== nextAuth.authenticated)
      ) {
        if (this.state.selectedPosts) this.setState({ selectedPosts: null });
      }
    }

    /**
     * Add/remove selected posts in state. Admin logic only.
     *
     * @param checked
     * @param data {object || array}
     */
    onHandleSelectPost(checked, data) {
      let selectedPosts = this.state.selectedPosts ? [...this.state.selectedPosts] : [];

      if (!isArray(data)) {
        const index = findIndex(selectedPosts, it => it.id === data.id);

        if (checked) selectedPosts.push(data);
        if (!checked && index >= 0) selectedPosts.splice(index, 1);
        if (!selectedPosts.length) selectedPosts = null;

        return this.setState({ selectedPosts });
      }

      selectedPosts = filter(selectedPosts, post => !includes(data, post));
      this.setState({ selectedPosts });
    }

    onHandleDeletePost(posts, multi = false, noConfirm = false) {
      const { i18n } = this;
      const { auth: { authenticated } = {} } = this.props;

      if (authenticated) {
        const apiCfg = deletePostConfig(multi, posts);
        if (!noConfirm) {
          return Notification.confirm(
            i18n('deleting'),
            i18n('deleteAreYouSure'),
            () => {
              this.api[apiCfg.apiMethod](apiCfg.apiUrl, {
                postData: apiCfg.postData
              })
                .then(() => this.afterRemove(apiCfg.afterRemove))
                .catch(error => reportError(error));
            },
            {
              okText: i18n('okText'),
              cancelText: i18n('cancelText')
            }
          );
        }
        this.api[apiCfg.apiMethod](apiCfg.apiUrl, {
          postData: apiCfg.postData
        })
          .then(() => this.afterRemove(apiCfg.afterRemove))
          .catch(error => reportError(error));
      }
    }

    afterRemove(posts = []) {
      // Remove deleted posts from state
      if (posts.length > 1) this.onHandleSelectPost(false, posts);

      Notification.success('Пост успешно удален.');

      // Make reload data provider club posts.
      emit('updateClubPosts');

      // Make reload data provider for TopicInfo and posts.
      emit('updatePosts');
    }

    render() {
      const props = {
        onHandleSelectPost: this.onHandleSelectPost,
        onHandleDeletePost: this.onHandleDeletePost,
        selectedPosts: this.state.selectedPosts
      };

      return <WrappedComponent {...this.props} {...props} />;
    }
}

return PostEditor;
}
